import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomersWithoutActivityReport extends Layout {
    excludabletextboxCollections: ExcludableTextbox;
    excludabletextboxOpsUsers: ExcludableTextbox;
    excludabletextboxSalesperson: ExcludableTextbox;
    sourceCustomersWithoutActivity: DataSource;
    switchPageBreak: Switch;
    textboxDate: Textbox;
    textboxGroupBy: Textbox;
}
